// Portal do Cliente (Onda 1): o lado da equipe (aba Portal na ficha do cliente, Acessos e Configuração), em pt, en e es.
const pt = {
  nome: 'Portal do cliente',
  abas: { acessos: 'Acessos ao portal', configuracao: 'Configuração do portal' },
  cartao: {
    titulo: 'Portal do cliente',
    acessos: 'Acessos',
    entregas: 'Documentos publicados',
    recebidos: 'Recebidos',
    trilha: 'Trilha',
    convidar: 'Convidar',
    verComo: 'Ver como o cliente',
    verComoAjuda: 'Abre o portal deste cliente em outra aba, só para leitura. A visualização fica na auditoria.',
    naoConfigurado: 'O endereço do portal ainda não foi configurado no servidor. Fale com a TI.',
    semAcessos: 'Ninguém deste cliente tem acesso ao portal ainda.',
    semEntregas: 'Nenhum documento publicado.',
    semRecebidos: 'O cliente ainda não enviou documentos.',
    semTrilha: 'Nada registrado ainda.',
    publicar: 'Publicar documento',
    endereco: 'Endereço do portal',
  },
  marcaEquipe: 'Equipe',
  estado: { convidado: 'Convite enviado', ativo: 'Ativo', revogado: 'Revogado' },
  papel: { dono: 'Dono', financeiro: 'Financeiro', dp: 'Departamento pessoal', fiscal: 'Fiscal', societario: 'Societário', colaborador: 'Colaborador' },
  area: { financeiro: 'Financeiro', dp: 'Departamento pessoal', fiscal: 'Fiscal', contabil: 'Contábil', societario: 'Societário', geral: 'Geral' },
  tipoEnvio: { extrato: 'Extrato bancário', nota_fiscal: 'Nota fiscal', folha_ponto: 'Folha de ponto', admissao: 'Admissão', comprovante: 'Comprovante', contrato: 'Contrato', outro: 'Outro' },
  acoes: { reenviar: 'Reenviar convite', revogar: 'Revogar', reativar: 'Reativar', remover: 'Tirar do portal', baixar: 'Baixar', acoes: 'Ações do acesso' },
  confirmar: {
    revogarTitulo: 'Revogar o acesso ao portal?',
    revogarTexto: 'A pessoa sai do portal na hora, em todos os aparelhos. Dá para reativar depois com um convite novo.',
    removerTitulo: 'Tirar o documento do portal?',
    removerTexto: 'O cliente deixa de ver o documento. O arquivo continua guardado.',
  },
  convite: {
    titulo: 'Convidar para o portal',
    texto: 'A pessoa recebe um e-mail da Malgo com o link de entrada (vale 7 dias). Não precisa criar senha.',
    contato: 'Contato cadastrado',
    outro: 'Outra pessoa',
    email: 'E-mail',
    nome: 'Nome',
    papel: 'Papel',
    papelAjuda: 'O Dono vê tudo; o Financeiro não vê o DP, e o DP não vê o Financeiro.',
    idioma: 'Idioma dos e-mails',
    enviar: 'Enviar convite',
    enviado: 'Convite enviado.',
  },
  publicar: {
    titulo: 'Publicar documento para o cliente',
    texto: 'O cliente vê o documento no portal e recebe o aviso no celular e por e-mail.',
    arquivo: 'Arquivo (PDF, imagem, planilha, documento ou XML de nota, até 25 MB)',
    escolherArquivo: 'Escolher arquivo',
    trocarArquivo: 'Trocar arquivo',
    tituloCampo: 'Título',
    area: 'Área',
    competencia: 'Competência (opcional)',
    descricao: 'Observação (opcional)',
    enviar: 'Publicar',
    publicado: 'Documento publicado.',
  },
  colunas: { pessoa: 'Pessoa', cliente: 'Cliente', papel: 'Papel', estado: 'Estado', ultimo: 'Último acesso', convidado: 'Convidado em', documento: 'Documento', publicado: 'Publicado', visto: 'Visto', baixado: 'Baixado', enviado: 'Enviado', por: 'Por', quando: 'Quando', acao: 'O quê' },
  nunca: 'Nunca',
  trilha: {
    cliente: 'Cliente',
    equipe: 'Equipe (ver como o cliente)',
    sistema: 'Sistema',
    acoes: {
      entrou: 'Entrou no portal',
      aceitou_convite: 'Aceitou o convite',
      aceitou_termo: 'Aceitou o termo de uso',
      visualizou: 'Visualizou',
      baixou: 'Baixou',
      enviou: 'Enviou um documento',
      enviou_mensagem: 'Mandou mensagem',
      exportou_dados: 'Baixou os próprios dados',
      anonimizou_conta: 'Anonimizou a conta',
      definiu_senha: 'Definiu a senha',
      removeu_senha: 'Removeu a senha',
      cadastrou_passkey: 'Cadastrou uma passkey',
      removeu_passkey: 'Removeu uma passkey',
      convidar: 'Convite enviado pela equipe',
      reenviar: 'Convite reenviado',
      revogar: 'Acesso revogado',
      revogado_por_desligamento: 'Acesso revogado: a pessoa saiu da equipe',
      reativar: 'Acesso reativado',
      publicar: 'Documento publicado',
      remover: 'Documento tirado do portal',
      ver_como_cliente: 'Equipe abriu a visualização',
      ver_como_cliente_link: 'Equipe gerou o link de visualização',
      editar: 'Papel alterado',
    },
    entidades: { 'contas.documento': 'fatura', 'portal.entrega': 'documento', 'portal.envio': 'documento enviado', 'portal.mensagens': 'mensagens' },
  },
  config: {
    saida: 'Saída do cliente',
    saidaTexto: 'Quando o último contrato do cliente é encerrado, o Portal fica em modo saída: só documentos, histórico financeiro e baixar os dados, sem cobranças novas nem chat. Passado o prazo, o acesso é revogado. Reativar o contrato devolve o acesso completo.',
    saidaDias: 'Dias de acesso depois do último contrato',
    saidaSalvar: 'Salvar prazo',
    saidaSalvo: 'Prazo salvo. Vale para os próximos encerramentos.',
    saidaAtual_one: '{{count}} dia de acesso depois do último contrato',
    saidaAtual_other: '{{count}} dias de acesso depois do último contrato',
    termos: 'Termo de uso do portal',
    termosTexto: 'O cliente aceita a versão vigente no primeiro acesso e de novo a cada versão publicada. O aceite fica registrado com data, IP e aparelho.',
    vigente: 'Vigente',
    aceites_one: '{{count}} aceite',
    aceites_other: '{{count}} aceites',
    nova: 'Publicar nova versão',
    versao: 'Versão',
    titulo: 'Título',
    texto: 'Texto',
    publicar: 'Publicar versão',
    publicado: 'Versão publicada. Os clientes aceitam no próximo acesso.',
    semTermo: 'Nenhum termo publicado: o cliente entra sem aceite. Publique o termo da Malgo Law antes do piloto.',
    endereco: 'Endereço do portal',
    naoConfigurado: 'Portal sem endereço configurado no servidor para este workspace (PORTAL_URL ou, no Sandbox, PORTAL_SANDBOX_URL).',
  },
  lista: { vazia: 'Ninguém tem acesso ao portal ainda. Abra a ficha de um cliente e convide a pessoa.', irParaClientes: 'Abrir Pessoas e empresas', filtro: 'Estado' },
};

const en: typeof pt = {
  nome: 'Client portal',
  abas: { acessos: 'Portal access', configuracao: 'Portal settings' },
  cartao: {
    titulo: 'Client portal',
    acessos: 'Access',
    entregas: 'Published documents',
    recebidos: 'Received',
    trilha: 'Audit trail',
    convidar: 'Invite',
    verComo: 'View as the client',
    verComoAjuda: 'Opens the portal of this client in another tab, read only. The view is recorded in the audit log.',
    naoConfigurado: 'The portal address is not configured on the server yet. Talk to IT.',
    semAcessos: 'Nobody from this client has portal access yet.',
    semEntregas: 'No published documents.',
    semRecebidos: 'The client has not sent documents yet.',
    semTrilha: 'Nothing recorded yet.',
    publicar: 'Publish document',
    endereco: 'Portal address',
  },
  marcaEquipe: 'Team',
  estado: { convidado: 'Invitation sent', ativo: 'Active', revogado: 'Revoked' },
  papel: { dono: 'Owner', financeiro: 'Finance', dp: 'Payroll and HR', fiscal: 'Tax', societario: 'Corporate', colaborador: 'Employee' },
  area: { financeiro: 'Finance', dp: 'Payroll and HR', fiscal: 'Tax', contabil: 'Accounting', societario: 'Corporate', geral: 'General' },
  tipoEnvio: { extrato: 'Bank statement', nota_fiscal: 'Invoice (NF)', folha_ponto: 'Timesheet', admissao: 'Hiring', comprovante: 'Receipt', contrato: 'Contract', outro: 'Other' },
  acoes: { reenviar: 'Resend invitation', revogar: 'Revoke', reativar: 'Reactivate', remover: 'Remove from portal', baixar: 'Download', acoes: 'Access actions' },
  confirmar: {
    revogarTitulo: 'Revoke portal access?',
    revogarTexto: 'The person leaves the portal right away, on every device. You can reactivate later with a new invitation.',
    removerTitulo: 'Remove the document from the portal?',
    removerTexto: 'The client no longer sees the document. The file stays stored.',
  },
  convite: {
    titulo: 'Invite to the portal',
    texto: 'The person gets an e-mail from Malgo with the sign-in link (valid for 7 days). No password needed.',
    contato: 'Registered contact',
    outro: 'Someone else',
    email: 'E-mail',
    nome: 'Name',
    papel: 'Role',
    papelAjuda: 'The Owner sees everything; Finance does not see Payroll, and Payroll does not see Finance.',
    idioma: 'Language of the e-mails',
    enviar: 'Send invitation',
    enviado: 'Invitation sent.',
  },
  publicar: {
    titulo: 'Publish a document to the client',
    texto: 'The client sees the document in the portal and gets a notification on the phone and by e-mail.',
    arquivo: 'File (PDF, image, spreadsheet, document or invoice XML, up to 25 MB)',
    escolherArquivo: 'Choose file',
    trocarArquivo: 'Change file',
    tituloCampo: 'Title',
    area: 'Area',
    competencia: 'Period (optional)',
    descricao: 'Note (optional)',
    enviar: 'Publish',
    publicado: 'Document published.',
  },
  colunas: { pessoa: 'Person', cliente: 'Client', papel: 'Role', estado: 'Status', ultimo: 'Last access', convidado: 'Invited on', documento: 'Document', publicado: 'Published', visto: 'Seen', baixado: 'Downloaded', enviado: 'Sent', por: 'By', quando: 'When', acao: 'What' },
  nunca: 'Never',
  trilha: {
    cliente: 'Client',
    equipe: 'Team (view as the client)',
    sistema: 'System',
    acoes: {
      entrou: 'Signed in to the portal',
      aceitou_convite: 'Accepted the invitation',
      aceitou_termo: 'Accepted the terms of use',
      visualizou: 'Viewed',
      baixou: 'Downloaded',
      enviou: 'Sent a document',
      enviou_mensagem: 'Sent a message',
      exportou_dados: 'Downloaded own data',
      anonimizou_conta: 'Anonymized the account',
      definiu_senha: 'Set the password',
      removeu_senha: 'Removed the password',
      cadastrou_passkey: 'Registered a passkey',
      removeu_passkey: 'Removed a passkey',
      convidar: 'Invitation sent by the team',
      reenviar: 'Invitation resent',
      revogar: 'Access revoked',
      revogado_por_desligamento: 'Access revoked: the person left the team',
      reativar: 'Access reactivated',
      publicar: 'Document published',
      remover: 'Document removed from the portal',
      ver_como_cliente: 'Team opened the client view',
      ver_como_cliente_link: 'Team created the view link',
      editar: 'Role changed',
    },
    entidades: { 'contas.documento': 'invoice', 'portal.entrega': 'document', 'portal.envio': 'sent document', 'portal.mensagens': 'messages' },
  },
  config: {
    saida: 'Client exit',
    saidaTexto: 'When the client\'s last contract ends, the Portal enters exit mode: only documents, billing history and data download, with no new charges or chat. After the period, access is revoked. Reactivating the contract restores full access.',
    saidaDias: 'Days of access after the last contract',
    saidaSalvar: 'Save period',
    saidaSalvo: 'Period saved. It applies to the next contract endings.',
    saidaAtual_one: '{{count}} day of access after the last contract',
    saidaAtual_other: '{{count}} days of access after the last contract',
    termos: 'Portal terms of use',
    termosTexto: 'The client accepts the current version at the first access and again at each published version. The acceptance is recorded with date, IP and device.',
    vigente: 'Current',
    aceites_one: '{{count}} acceptance',
    aceites_other: '{{count}} acceptances',
    nova: 'Publish a new version',
    versao: 'Version',
    titulo: 'Title',
    texto: 'Text',
    publicar: 'Publish version',
    publicado: 'Version published. Clients accept it at their next access.',
    semTermo: 'No terms published: the client signs in without acceptance. Publish the Malgo Law terms before the pilot.',
    endereco: 'Portal address',
    naoConfigurado: 'Portal without an address configured on the server for this workspace (PORTAL_URL or, in the Sandbox, PORTAL_SANDBOX_URL).',
  },
  lista: { vazia: 'Nobody has portal access yet. Open a client record and invite the person.', irParaClientes: 'Open People and companies', filtro: 'Status' },
};

const es: typeof pt = {
  nome: 'Portal del cliente',
  abas: { acessos: 'Accesos al portal', configuracao: 'Configuración del portal' },
  cartao: {
    titulo: 'Portal del cliente',
    acessos: 'Accesos',
    entregas: 'Documentos publicados',
    recebidos: 'Recibidos',
    trilha: 'Registro',
    convidar: 'Invitar',
    verComo: 'Ver como el cliente',
    verComoAjuda: 'Abre el portal de este cliente en otra pestaña, solo lectura. La vista queda en la auditoría.',
    naoConfigurado: 'La dirección del portal todavía no está configurada en el servidor. Habla con TI.',
    semAcessos: 'Nadie de este cliente tiene acceso al portal todavía.',
    semEntregas: 'Ningún documento publicado.',
    semRecebidos: 'El cliente todavía no envió documentos.',
    semTrilha: 'Nada registrado todavía.',
    publicar: 'Publicar documento',
    endereco: 'Dirección del portal',
  },
  marcaEquipe: 'Equipo',
  estado: { convidado: 'Invitación enviada', ativo: 'Activo', revogado: 'Revocado' },
  papel: { dono: 'Dueño', financeiro: 'Finanzas', dp: 'Personal y nómina', fiscal: 'Fiscal', societario: 'Societario', colaborador: 'Colaborador' },
  area: { financeiro: 'Finanzas', dp: 'Personal y nómina', fiscal: 'Fiscal', contabil: 'Contable', societario: 'Societario', geral: 'General' },
  tipoEnvio: { extrato: 'Extracto bancario', nota_fiscal: 'Factura fiscal', folha_ponto: 'Registro de horas', admissao: 'Contratación', comprovante: 'Comprobante', contrato: 'Contrato', outro: 'Otro' },
  acoes: { reenviar: 'Reenviar invitación', revogar: 'Revocar', reativar: 'Reactivar', remover: 'Quitar del portal', baixar: 'Descargar', acoes: 'Acciones del acceso' },
  confirmar: {
    revogarTitulo: '¿Revocar el acceso al portal?',
    revogarTexto: 'La persona sale del portal al instante, en todos los dispositivos. Se puede reactivar después con una invitación nueva.',
    removerTitulo: '¿Quitar el documento del portal?',
    removerTexto: 'El cliente deja de ver el documento. El archivo sigue guardado.',
  },
  convite: {
    titulo: 'Invitar al portal',
    texto: 'La persona recibe un correo de Malgo con el enlace de acceso (vale 7 días). No necesita crear contraseña.',
    contato: 'Contacto registrado',
    outro: 'Otra persona',
    email: 'Correo',
    nome: 'Nombre',
    papel: 'Rol',
    papelAjuda: 'El Dueño ve todo; Finanzas no ve Personal, y Personal no ve Finanzas.',
    idioma: 'Idioma de los correos',
    enviar: 'Enviar invitación',
    enviado: 'Invitación enviada.',
  },
  publicar: {
    titulo: 'Publicar documento para el cliente',
    texto: 'El cliente ve el documento en el portal y recibe el aviso en el celular y por correo.',
    arquivo: 'Archivo (PDF, imagen, hoja de cálculo, documento o XML de factura, hasta 25 MB)',
    escolherArquivo: 'Elegir archivo',
    trocarArquivo: 'Cambiar archivo',
    tituloCampo: 'Título',
    area: 'Área',
    competencia: 'Período (opcional)',
    descricao: 'Observación (opcional)',
    enviar: 'Publicar',
    publicado: 'Documento publicado.',
  },
  colunas: { pessoa: 'Persona', cliente: 'Cliente', papel: 'Rol', estado: 'Estado', ultimo: 'Último acceso', convidado: 'Invitado el', documento: 'Documento', publicado: 'Publicado', visto: 'Visto', baixado: 'Descargado', enviado: 'Enviado', por: 'Por', quando: 'Cuándo', acao: 'Qué' },
  nunca: 'Nunca',
  trilha: {
    cliente: 'Cliente',
    equipe: 'Equipo (ver como el cliente)',
    sistema: 'Sistema',
    acoes: {
      entrou: 'Entró al portal',
      aceitou_convite: 'Aceptó la invitación',
      aceitou_termo: 'Aceptó los términos de uso',
      visualizou: 'Vio',
      baixou: 'Descargó',
      enviou: 'Envió un documento',
      enviou_mensagem: 'Envió un mensaje',
      exportou_dados: 'Descargó sus datos',
      anonimizou_conta: 'Anonimizó la cuenta',
      definiu_senha: 'Definió la contraseña',
      removeu_senha: 'Quitó la contraseña',
      cadastrou_passkey: 'Registró una passkey',
      removeu_passkey: 'Quitó una passkey',
      convidar: 'Invitación enviada por el equipo',
      reenviar: 'Invitación reenviada',
      revogar: 'Acceso revocado',
      revogado_por_desligamento: 'Acceso revocado: la persona dejó el equipo',
      reativar: 'Acceso reactivado',
      publicar: 'Documento publicado',
      remover: 'Documento quitado del portal',
      ver_como_cliente: 'El equipo abrió la vista',
      ver_como_cliente_link: 'El equipo generó el enlace de vista',
      editar: 'Rol cambiado',
    },
    entidades: { 'contas.documento': 'factura', 'portal.entrega': 'documento', 'portal.envio': 'documento enviado', 'portal.mensagens': 'mensajes' },
  },
  config: {
    saida: 'Salida del cliente',
    saidaTexto: 'Cuando termina el último contrato del cliente, el Portal queda en modo salida: solo documentos, historial financiero y descarga de datos, sin cobros nuevos ni chat. Pasado el plazo, el acceso se revoca. Reactivar el contrato devuelve el acceso completo.',
    saidaDias: 'Días de acceso después del último contrato',
    saidaSalvar: 'Guardar plazo',
    saidaSalvo: 'Plazo guardado. Vale para los próximos cierres.',
    saidaAtual_one: '{{count}} día de acceso después del último contrato',
    saidaAtual_other: '{{count}} días de acceso después del último contrato',
    termos: 'Términos de uso del portal',
    termosTexto: 'El cliente acepta la versión vigente en el primer acceso y de nuevo con cada versión publicada. La aceptación queda registrada con fecha, IP y dispositivo.',
    vigente: 'Vigente',
    aceites_one: '{{count}} aceptación',
    aceites_other: '{{count}} aceptaciones',
    nova: 'Publicar nueva versión',
    versao: 'Versión',
    titulo: 'Título',
    texto: 'Texto',
    publicar: 'Publicar versión',
    publicado: 'Versión publicada. Los clientes la aceptan en el próximo acceso.',
    semTermo: 'Ningún término publicado: el cliente entra sin aceptación. Publica los términos de Malgo Law antes del piloto.',
    endereco: 'Dirección del portal',
    naoConfigurado: 'Portal sin dirección configurada en el servidor para este workspace (PORTAL_URL o, en el Sandbox, PORTAL_SANDBOX_URL).',
  },
  lista: { vazia: 'Nadie tiene acceso al portal todavía. Abre la ficha de un cliente e invita a la persona.', irParaClientes: 'Abrir Personas y empresas', filtro: 'Estado' },
};

export const i18n = { pt, en, es };
